<template>
  <!-- 信息摘要 -->
  <a-modal
    title="信息摘要"
    :visible="isVisible"
    :destroyOnClose="true"
    :maskClosable="false"
    width="50%"
    :footer="null"
    @cancel="close"
  >
    <a-row :gutter="16">
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{ dataValue.profit || 0 }}</span>
          </div>
          <div class="summary-item-text">供应商应付金额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">换货单总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">发货单总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">采购总金额</div>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="16" style="margin-top: 20px;">
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">采购退货总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">付款总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">采购已冲销总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">采购未付款总额</div>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="16" style="margin-top: 20px;">
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">退货总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">付款发票总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">未付款计划</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">费用报销</div>
        </div>
      </a-col>
    </a-row>
    <a-row :gutter="16" style="margin-top: 20px;">
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">财务已收款总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">财务已付款总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">应收款总额</div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="summary-item">
          <div class="summary-item-value">
            <span>¥</span>
            <span class="amount">{{  0 }}</span>
          </div>
          <div class="summary-item-text">应付款总额</div>
        </div>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
export default {
  name: 'summaryInfo',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get () {
        return this.dialogVisible
      },
      set () {
        this.close()
      }
    }
  },
  data () {
    return {
      dataValue: {}
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
  /deep/ .ant-modal {
    padding-bottom: 0;
    box-sizing: border-box;

    .ant-modal-content {
      min-height: auto;
    }
  }

  .summary-item {
    text-align: center;
    padding: 10px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background-color: #fafafa;

    .summary-item-value {
      font-size: 24px;
      font-weight: 600;
      color: #1890ff;
      font-size: 16px;

      .amount {
        font-size: 26px;
        font-weight: bold;
      }
    }

    .summary-item-text {
      font-size: 14px;
      color: #666;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/purchase/supplier/summaryInfo.vue